import { render } from "./ModalsNewRaffle.vue?vue&type=template&id=579a023d"
import script from "./ModalsNewRaffle.vue?vue&type=script&lang=js"
export * from "./ModalsNewRaffle.vue?vue&type=script&lang=js"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__